// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___2Z9yy","visible-sm":"visible-sm___2Z5M0","visible-md":"visible-md___2qctC","visible-lg":"visible-lg___1otbB","row":"row___1L6UW","hidden-xs":"hidden-xs___2f9wj","hidden-sm":"hidden-sm___ATJII","hidden-md":"hidden-md___2P-1P","hidden-lg":"hidden-lg___1tMpt","small-page-title":"small-page-title___3j1rL","large-page-title":"large-page-title___2jVIL","issue-top-headline":"issue-top-headline___1FOaE","issue-top-copy":"issue-top-copy___35FcQ","anchor":"anchor___2t_Ic","page":"page___2AfvA page___2ZhHk","faq-wrap":"faq-wrap___2jFry","scroll-to-item":"scroll-to-item___U3d0h h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FAQs/FAQs.css
// module id = 953
// module chunks = 0